import React from 'react';
import { TextField, Autocomplete } from '@mui/material';

interface Agent {
    label: string;
    value: string;
    fare: number;
    KG14Rate: number;
    KG19Rate: number;
    KG5Rate: number;
    refillCount: number;
    cylinderReceived14KG: number;
    cylinderReceived19KG: number;
    cylinderReceived5KG: number;
}

interface AgentSearchProps {
    onSelectAgent: (agent: Agent | string | null) => void;
    list: Array<Agent>;
    loading?: boolean;
}

const AgentSearch: React.FC<AgentSearchProps> = ({ onSelectAgent, list, loading }) => {
    return (
        <Autocomplete
            freeSolo
            options={list}
            getOptionLabel={(option) => (typeof option === 'string' ? option : option.label)}
            onChange={(event, newValue) => {
                onSelectAgent(newValue);
            }}
            loading={loading}
            renderInput={(params) => <TextField {...params} label="Search Agent" variant="outlined" />}
        />
    );
};

export default AgentSearch;